import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createOrganizer } = EventsApiService();

export const useCreateOrganizer = (id: any) => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return createOrganizer(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (id) {
                    message.success("Organizer has been updated successfully!!");
                } else {
                    message.success("Organizer has been created successfully!!");
                }
            },
        },
    );
};
